import React, { createContext, useContext, useState } from "react";
import {StockServices}  from '../services/stockServices';

// 1. Create Context
const AnalyticsContext = createContext(null);

// 2. Provider Component
export const AnalyticsProvider = ({ children }) => {
  const [analyticsData, setAnalyticsData] = useState({data:{},isloading:false});

  const trackEvent = (eventName, payload = {}) => {
    setAnalyticsData(prev => ({
      ...prev,
      [eventName]: payload,
    }));

    // You can also send this to an API or analytics service here
    console.log("Tracked Event:", eventName, payload);
  };


  const getAnalyticsdata = async () => {
    setAnalyticsData({isloading:true});
    const response = await StockServices.getanalytics();
    if (response && response.data) {
      setAnalyticsData({data:response.data,isloading:false});
    }
    return analyticsData;
  }

  const value = {
    analyticsData,
    trackEvent,
    getAnalyticsdata
  };

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};

// 3. Custom Hook for easy usage
export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error("useAnalytics must be used within an AnalyticsProvider");
  }
  return context;
};
